'use strict';

exports.__esModule = true;

var _ramda = /*#__PURE__*/require('ramda');

var compareLength = /*#__PURE__*/(0, _ramda.curry)(function (comparator, value, list) {
  return (0, _ramda.compose)(comparator(value), _ramda.length)(list);
});

exports.default = compareLength;


//////////////////
// WEBPACK FOOTER
// ./~/ramda-adjunct/lib/internal/compareLength.js
// module id = 90
// module chunks = 168707334958949